<!-- Contains course card header and submitted,notsubmitted redirection-->
<template>
  <div class="content container">
    <div>
      <div class="form-group card terms-card">
        <div className="card-body">
          <div class="table-responsive">
            <table class="table table-borderless">
              <thead>
                <tr>
                  <th scope="col" style="width: 200px">Term</th>
                  <th
                    scope="col"
                    style="width: 250px"
                    v-if="isDepartmentChair == true"
                  >
                    Department
                  </th>
                  <th
                    scope="col"
                    style="width: 250px"
                    v-if="isDepartmentChair == true"
                  >
                    Course #
                  </th>
                  <th scope="col" style="width: 250px">Filter by</th>
                  <th
                    scope="col"
                    style="width: 250px"
                    v-if="isDepartmentChair == false"
                  ></th>
                  <th
                    scope="col"
                    style="width: 250px"
                    v-if="isDepartmentChair == false"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <select
                      class="form-select"
                      v-model="termId"
                      @change="onTermChange()"
                    >
                      <option value="null" disabled>Select Term</option>
                      <option
                        v-for="option in terms"
                        :key="option.id"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </td>

                  <td v-if="isDepartmentChair == true">
                    <select
                      :disabled="!termId"
                      class="form-select"
                      v-model="departmentId"
                      @change="onDepartmentChange($event)"
                    >
                      <option selected="true" value="null" disabled>
                        Select Department
                      </option>
                      <option
                        v-for="option in departments"
                        :key="option.id"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </td>
                  <td v-if="isDepartmentChair == true">
                    <select
                      :disabled="!departmentId"
                      class="form-select"
                      v-model="courseId"
                      @change="onCourseChange()"
                    >
                      <option value="null" disabled>Select Course</option>
                      <option
                        v-for="option in courses"
                        :key="option.id"
                        :value="option.sisCourseId"
                      >
                        {{ option.sisCourseId }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select
                      class="form-select"
                      :disabled="!termId"
                      v-model="filterData.adoptionTypes"
                      @change="getResults()"
                    >
                      <option :value="2">All courses</option>
                      <option :value="0">Submitted courses</option>
                      <option :value="1">Not-Submitted courses</option>
                    </select>
                  </td>
                  <td v-if="isDepartmentChair == false"></td>
                  <td v-if="isDepartmentChair == false"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row" v-if="isDepartmentChair == true">
            <div class="col-md-6 cls-upload">
              <label
                for="formFileMd"
                class="form-label font-weight-bold"
                style="font-weight: bold"
                >Choose file to upload batch file</label
              >
              <input
                class="form-control form-control-md"
                id="formFileMd"
                type="file"
                accept=".csv"
                @change="handleFileUpload($event)"
              />
            </div>
            <div class="col-md-4 mt-4 btn-csv">
              <button
                type="button"
                class="btn btn-primary"
                @click="adoptionsByCSV()"
              >
                <span class="material-icons-outlined btn-icon">
                  check_circle
                </span>
                Upload Batch file
              </button>
            </div>
            <div class="col-md-2"></div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-sm-6 col-md-5" v-if="isDepartmentChair == true">
              <div class="row align-center">
                <div v-show="modalActive">
                  <CsvValidationsModal
                    :validationResults="csvValidations"
                    @close="closeModal($event)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="shouldLoad && adoptions.length > 0">
        <div
          class="card"
          v-for="(submittedBooks, index) in paginatedData"
          :key="submittedBooks.id || pageStartIndex + index"
          :value="submittedBooks.id"
        >
          <div v-if="submittedBooks.adoptions.length > 0">
            <SubmittedCard
              :_submittedBooks="adoptions[pageStartIndex + index]"
              @getCourseBooks="getResults({ preservePage: true })"
            />
          </div>
          <div v-else-if="submittedBooks.adoptions.length == 0">
            <NotSubmittedCard
              :notSubmittedBooks="submittedBooks"
              :selectedTermId="termId"
            @getCourseBooks="getNotSubmittedAdoptions()"
            />
          </div>
          <div v-else>
            Sorry, there are no courses matching your selected criteria
          </div>
        </div>
      </div>

      <div v-else class="card">
        <div class="card-body cardnote">
          <blockquote class="blockquote mb-0">
            No courses found!!
            <span
              class="material-icons-outlined align-middle"
              v-if="filterData.adoptionTypes == 1"
            >
              sentiment_satisfied
            </span>
            <span class="material-icons-outlined align-middle" v-else>
              sentiment_dissatisfied
            </span>
          </blockquote>
        </div>
      </div>

      <nav aria-label="Page navigation example" v-if="adoptions.length">
        <ul class="pagination justify-content-center">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              aria-label="Previous"
              @click.prevent="prevPage"
            >
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li
            class="page-item"
            v-for="page in pages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">
              <span style="color: #000">{{ page }}</span>
            </a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              aria-label="Next"
              @click.prevent="nextPage"
            >
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import SubmittedCard from "../Faculty/SubmittedCard.vue";
import NotSubmittedCard from "../Faculty/NotSubmittedCard.vue";
import CsvValidationsModal from "../Faculty/CsvValidationsResult.vue";
import { ref } from "vue";
import Paginate from "vue3-paginate";
const modalActive = ref(false);
export default {
  name: "CardView",
  data() {
    return {
      rows: 100,
      totalRows: 10,
      //currentPage: 1,
      termId: null,
      departmentId: null,
      isDepartmentChair: false,
      file: "",
      csvValidations: "",
      departments: [],
      adoptions: [],
      page: 1,
      perPage: 5,
      shouldLoad: false,
      terms: [],
      courseList: [],
      courseId: null,
      courses: [],
      currentPage: 1,
      pageNumber: 1,
      noOfpageNumber: 0,
      pageNumberList: [],
      filterData: {
        instructorId: this.$store.state.sisUserId,
        adoptionTypes: 2,
        termId: 266,
      },
      itemsPerPage: 4,
    };
  },
  components: {
    SubmittedCard,
    NotSubmittedCard,
    CsvValidationsModal,
    // eslint-disable-next-line vue/no-unused-components
    Paginate,
  },
  setup() {
    const toggleModal = () => {
      modalActive.value = !modalActive.value;
    };
    return { modalActive, toggleModal };
  },

  methods: {
    getStateStorageKey() {
      return "faculty-card-view-state";
    },
    isSameId(left, right) {
      return String(left) === String(right);
    },
    saveViewState() {
      sessionStorage.setItem(
        this.getStateStorageKey(),
        JSON.stringify({
          termId: this.termId,
          departmentId: this.departmentId,
          courseId: this.courseId,
          adoptionTypes: this.filterData.adoptionTypes,
          currentPage: this.currentPage,
        })
      );
    },
    loadViewState() {
      const rawState = sessionStorage.getItem(this.getStateStorageKey());
      if (!rawState) {
        return;
      }

      let savedState = null;
      try {
        savedState = JSON.parse(rawState);
      } catch (error) {
        sessionStorage.removeItem(this.getStateStorageKey());
        return;
      }

      this.termId = savedState.termId ?? this.termId;
      this.departmentId = savedState.departmentId ?? this.departmentId;
      this.courseId = savedState.courseId ?? this.courseId;
      this.filterData.adoptionTypes =
        savedState.adoptionTypes ?? this.filterData.adoptionTypes;
      this.currentPage = savedState.currentPage || 1;
    },
    clampCurrentPage() {
      if (this.currentPage < 1) {
        this.currentPage = 1;
        return;
      }

      if (this.totalPages > 0 && this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    },
    // getPage() {

    //   this.$store
    //     .dispatch("getPages", {
    //       InstructorId: this.$store.state.sisUserId,
    //       TermId: this.termId,
    //       courseID: "",
    //       departmentID: this.departmentId,
    //       AdoptionTypes: this.filterData.adoptionTypes,
    //     })
    //     .then((response) => {
    //       this.noOfpageNumber = response["data"];
    //       this.pageNumberList = new Array(this.noOfpageNumber)
    //         .fill(true)
    //         .map((e, i) => i + 1);
    //       console.log(
    //         "Page Number : ",
    //         this.noOfpageNumber,
    //         this.pageNumberList
    //       );
    //     });
    // },
    getCourses() {
      return this.$store
        .dispatch("getAdminCoursesByDepartment", {
          departmentId: this.departmentId,
          termId: this.termId,
        })
        .then((response) => {
          this.courses = response["data"];
        });
    },
    onTermChange() {
      this.currentPage = 1;
      if (this.isDepartmentChair == true) {
        this.departmentId = null;
        this.courseId = null;
        this.shouldLoad = false;
        this.adoptions = [];
        this.AdminViewAdoptions();
      } else if (this.isDepartmentChair == false) {
        this.FacultyViewAdoptions();
      }
      this.saveViewState();
    },
    AdminViewAdoptions() {
      if (this.isDepartmentChair == true) {
        this.$store.dispatch("getPresentAndFutureTerms").then((response) => {
          this.filterData.terms = response["data"];
          this.getAdminDepartments();
        });
      }
    },
    FacultyViewAdoptions() {
      this.getResults();
    },
    onCourseChange() {
      this.getResults();
      this.saveViewState();
    },
    onDepartmentChange(e) {
      var deptId = e.target.value;
      this.courseId = null;
      this.departmentId = deptId;

      this.getCourses();
      this.getResults();
      this.saveViewState();
    },

    getResults(options = {}) {
      const preservePage = options.preservePage === true;
      if (!preservePage) {
        this.currentPage = 1;
      }

      if (this.isDepartmentChair == false) {
        this.shouldLoad = false;
        this.adoptions = [];
        //this.filterData
        this.$store
          .dispatch("getAdoptionsofInstructor", {
            InstructorId: this.$store.state.sisUserId,
            AdoptionTypes: this.filterData.adoptionTypes,
            TermId: this.termId,
          })
          .then((response) => {
            this.adoptions = response["data"];
            console.log("adoptions", this.adoptions);
            this.clampCurrentPage();
            this.saveViewState();
            this.shouldLoad = true;
          });
      } else if (this.isDepartmentChair == true) {
        this.shouldLoad = false;
        this.adoptions = [];

        if (this.courseId === null && this.departmentId !== null) {
          this.$store
            .dispatch("getAdoptionsByAdmin", {
              InstructorId: this.$store.state.sisUserId,
              TermId: this.termId,
              courseID: "",
              departmentID: this.departmentId,
              AdoptionTypes: this.filterData.adoptionTypes,
              currentPage: this.pageNumber,
            })
            .then((response) => {
              console.log("in admin");
              console.log(response);
              this.adoptions = response["data"];
              // if (response.data[0].course.sections[0].adoptions != []) {
              //   if (response.data[0].course.sections[0].adoptions[0].bookId) {
              //     this.$store.state.notesVisible = true;
              //   }
              // }

              this.clampCurrentPage();
              this.saveViewState();
              this.shouldLoad = true;
            });
        } else if (this.courseId !== null && this.departmentId !== null) {
          this.$store
            .dispatch("getAdoptionsByAdmin", {
              InstructorId: this.$store.state.sisUserId,
              TermId: this.termId,
              courseID: this.courseId.toString(),
              departmentID: this.departmentId,
              AdoptionTypes: this.filterData.adoptionTypes,
              currentPage: this.pageNumber,
            })
            .then((response) => {
              this.adoptions = response["data"];
              this.clampCurrentPage();
              this.saveViewState();
              this.shouldLoad = true;
            });
        }
      } else {
        this.shouldLoad = false;
        this.adoptions = [];
        this.saveViewState();
      }
    },
    closeModal() {
      this.toggleModal();
      return;
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    adoptionsByCSV() {
      if (this.file == "") {
        this.$store.dispatch("showToaster", {
          message: "Please choose a file to upload!",
          status: false,
        });
        console.log("file is empty");
      } else {
        var currentFile = this.file;
        const formData = new FormData();
        formData.append("file", currentFile);
        this.$store
          .dispatch("updateAdoptionsByCSV", formData)
          .then((response) => {
            this.csvValidations = response["data"];
            this.toggleModal();
          });
        currentFile = undefined;
      }
    },
    getCoursCards() {
      console.log("called ");
      this.shouldLoad = false;
      this.$store
        .dispatch(
          "getAdoptionsofInstructor",
          this.$store.state.facultyselections
        )
        .then(() => {
          this.shouldLoad = true;
        });
    },
    getNotSubmittedAdoptions() {
      this.getResults({ preservePage: true });
    },

    getAdminDepartments() {
      return this.$store
        .dispatch("getAdminDepartments", {
          sisUserId: this.$store.state.sisUserId, //this.sisUserId,
          termId: this.termId,
        })
        .then((response) => {
          this.departments = response["data"].sort((a, b) => a.name.localeCompare(b.name));
          console.log(this.departments)
        });
    },
    getTerms() {
      this.$store.dispatch("getPresentAndFutureTerms").then((response) => {
        this.terms = response["data"];

        const restoredTermExists = this.terms.some((term) =>
          this.isSameId(term.id, this.termId)
        );
        this.termId = restoredTermExists ? this.termId : this.terms[0]?.id || null;
        this.filterData.termId = this.termId;

        if (this.isDepartmentChair == false) {
          this.getResults({ preservePage: true });
          return;
        }

        this.getAdminDepartments().then(() => {
          const restoredDepartmentExists = this.departments.some((department) =>
            this.isSameId(department.id, this.departmentId)
          );

          if (!restoredDepartmentExists) {
            this.departmentId = null;
            this.courseId = null;
            this.saveViewState();
            return;
          }

          this.getCourses().then(() => {
            const restoredCourseExists = this.courses.some((course) =>
              this.isSameId(course.sisCourseId, this.courseId)
            );

            if (!restoredCourseExists) {
              this.courseId = null;
            }

            this.getResults({ preservePage: true });
          });
        });
      });
    },

    changePage(page) {
      this.currentPage = page;
      this.saveViewState();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.saveViewState();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.saveViewState();
      }
    },
  },

  mounted() {
    this.isDepartmentChair =
      localStorage.getItem("isDepartmentChair") == "true";
    this.loadViewState();
    this.getTerms();
    this.courseList = this.$store.state.student.courseFinder;
  },
  computed: {
    pageStartIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    paginatedData() {
      const endIndex = this.pageStartIndex + this.itemsPerPage;
      return this.adoptions.slice(this.pageStartIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.adoptions.length / this.itemsPerPage);
    },
    pages() {
      const range = [];
      for (let i = 1; i <= this.totalPages; i++) {
        range.push(i);
      }
      return range;
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: 15px;
}

.cardnote {
  background: #e3f5e64b;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-csv {
  margin-top: 1.9rem !important;
}
.cls-upload {
  margin-left: 8px;
}
/* Custom styles for pagination nav */
.pagination .page-item.disabled .page-link {
  color: #6c757d;
  background-color: #e3e4e6;
  border-color: #dee2e6;
  overflow: hidden;
}

.pagination .page-item.active .page-link {
  /* z-index: 3; */
  z-index: 0;
  color: #fff;
  background-color: #bbe7c5;
  border-color: #bbe7c5;
}

.pagination .page-item a.page-link {
  color: #000;
  border: 1px solid #000000;
}

.pagination .page-item a.page-link:hover {
  color: #fff;
  background-color: #bbe7c5;
  border-color: #bbe7c5;
}

.pagination .page-item.active a.page-link {
  border-width: 1px;
}
</style>